/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Helper functions
const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

// Flickity arrows - Image Gallery - PDP
document.addEventListener('DOMContentLoaded', function(){
  const body = document.querySelector('body');
  const miniCartEl = document.getElementById("mini-cart");
  const productInstructionsPage = document.querySelector('.product__wrapper--game-instructions-page')

  setTimeout(function(){
    if(window.innerWidth > 640 && body.classList.contains('template-product') || window.innerWidth > 640 && productInstructionsPage){
      const arrowLeft = document.querySelector('.flickity-button.previous');
      const arrowRight = document.querySelector('.flickity-button.next');
      arrowLeft.innerHTML = ` <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3832 0.000488281C12.1932 0.0081703 12.0081 0.0709075 11.8518 0.182301L0.438822 8.15113C0.163776 8.3419 0 8.65816 0 8.99744C0 9.33675 0.163776 9.65426 0.438822 9.84503L11.8518 17.8217C12.1581 18.0355 12.5557 18.0586 12.8833 17.8819C13.212 17.7039 13.4171 17.3557 13.4171 16.9754L12.8833 12.585L31.0036 12.9218C31.5524 12.9193 31.9975 12.4647 32 11.9014V6.10274C32.0025 5.5368 31.5562 5.07589 31.0036 5.07461H13.9983L13.4171 1.02858C13.4184 0.750736 13.3083 0.483128 13.1133 0.289808C12.9183 0.0951921 12.6545 -0.00847632 12.3832 0.000488281Z" fill="black"/>
        </svg>`;
      arrowRight.innerHTML = `<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.6149 0.213944C19.8049 0.221444 19.9899 0.282693 20.1461 0.391445L31.5573 8.17129C31.8323 8.35754 31.9961 8.66629 31.9961 8.99753C31.9961 9.32879 31.8323 9.63877 31.5573 9.82501L20.1461 17.6125C19.8399 17.8213 19.4424 17.8438 19.1149 17.6713C18.7861 17.4975 18.5811 17.1575 18.5811 16.7863L19.1149 12.5L0.997435 12.8289C0.448698 12.8264 0.00367546 12.3826 0.00117874 11.8326V6.17147C-0.00132179 5.61896 0.444923 5.16898 0.997435 5.16773H18L18.5811 1.21765C18.5799 0.946399 18.6899 0.685138 18.8849 0.496402C19.0799 0.306402 19.3436 0.205192 19.6149 0.213944Z" fill="black"/>
        </svg>`;
    }
  }, 800);

  setTimeout(function(){
    if(window.innerWidth < 640 && body.classList.contains('template-product') || window.innerWidth < 640 && productInstructionsPage){
      const arrowLeftMobile = document.querySelector('.product__media-prev-next[data-action="prev"]');
      const arrowRightMobile = document.querySelector('.product__media-prev-next[data-action="next"]');
      arrowLeftMobile.innerHTML = ` <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3832 0.000488281C12.1932 0.0081703 12.0081 0.0709075 11.8518 0.182301L0.438822 8.15113C0.163776 8.3419 0 8.65816 0 8.99744C0 9.33675 0.163776 9.65426 0.438822 9.84503L11.8518 17.8217C12.1581 18.0355 12.5557 18.0586 12.8833 17.8819C13.212 17.7039 13.4171 17.3557 13.4171 16.9754L12.8833 12.585L31.0036 12.9218C31.5524 12.9193 31.9975 12.4647 32 11.9014V6.10274C32.0025 5.5368 31.5562 5.07589 31.0036 5.07461H13.9983L13.4171 1.02858C13.4184 0.750736 13.3083 0.483128 13.1133 0.289808C12.9183 0.0951921 12.6545 -0.00847632 12.3832 0.000488281Z" fill="black"/>
        </svg>`;
      arrowRightMobile.innerHTML = `<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.6149 0.213944C19.8049 0.221444 19.9899 0.282693 20.1461 0.391445L31.5573 8.17129C31.8323 8.35754 31.9961 8.66629 31.9961 8.99753C31.9961 9.32879 31.8323 9.63877 31.5573 9.82501L20.1461 17.6125C19.8399 17.8213 19.4424 17.8438 19.1149 17.6713C18.7861 17.4975 18.5811 17.1575 18.5811 16.7863L19.1149 12.5L0.997435 12.8289C0.448698 12.8264 0.00367546 12.3826 0.00117874 11.8326V6.17147C-0.00132179 5.61896 0.444923 5.16898 0.997435 5.16773H18L18.5811 1.21765C18.5799 0.946399 18.6899 0.685138 18.8849 0.496402C19.0799 0.306402 19.3436 0.205192 19.6149 0.213944Z" fill="black"/>
        </svg>`;
    }
  }, 900);

  if (body.classList.contains('template-product') || productInstructionsPage) {
    const zoomBtn = document.querySelector('.product__zoom-button');
    zoomBtn.addEventListener('click', (evt) => {
      const zoomArrowLeft = document.querySelector('.pswp__button.prev-next-button--prev');
      const zoomArrowRight = document.querySelector('.pswp__button.prev-next-button--next');
      zoomArrowLeft.innerHTML = ` <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3832 0.000488281C12.1932 0.0081703 12.0081 0.0709075 11.8518 0.182301L0.438822 8.15113C0.163776 8.3419 0 8.65816 0 8.99744C0 9.33675 0.163776 9.65426 0.438822 9.84503L11.8518 17.8217C12.1581 18.0355 12.5557 18.0586 12.8833 17.8819C13.212 17.7039 13.4171 17.3557 13.4171 16.9754L12.8833 12.585L31.0036 12.9218C31.5524 12.9193 31.9975 12.4647 32 11.9014V6.10274C32.0025 5.5368 31.5562 5.07589 31.0036 5.07461H13.9983L13.4171 1.02858C13.4184 0.750736 13.3083 0.483128 13.1133 0.289808C12.9183 0.0951921 12.6545 -0.00847632 12.3832 0.000488281Z" fill="black"/>
        </svg>`;
      zoomArrowRight.innerHTML = `<svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.6149 0.213944C19.8049 0.221444 19.9899 0.282693 20.1461 0.391445L31.5573 8.17129C31.8323 8.35754 31.9961 8.66629 31.9961 8.99753C31.9961 9.32879 31.8323 9.63877 31.5573 9.82501L20.1461 17.6125C19.8399 17.8213 19.4424 17.8438 19.1149 17.6713C18.7861 17.4975 18.5811 17.1575 18.5811 16.7863L19.1149 12.5L0.997435 12.8289C0.448698 12.8264 0.00367546 12.3826 0.00117874 11.8326V6.17147C-0.00132179 5.61896 0.444923 5.16898 0.997435 5.16773H18L18.5811 1.21765C18.5799 0.946399 18.6899 0.685138 18.8849 0.496402C19.0799 0.306402 19.3436 0.205192 19.6149 0.213944Z" fill="black"/>
        </svg>`;
    });
  }

  function callNostoLoadRecommendations() {
    if (window.nostojs) {
      window.nostojs((api) => {
        api.loadRecommendations({ skipPageViews: true, skipEvents: true });
      });
    }
  }

  function lineItemToHtml(item) {
    return `
      <div class="line_item">
        <span class="product_id">${item.product_id}</span>
        <span class="sku_id">${item.sku}</span>
        <span class="quantity">${item.quantity}</span>
        <span class="name">${item.title}</span>
        <span class="unit_price">${item.price}</span>
        <span class="price_currency_code">${window.Shopify.currency.active}</span>
      </div>
    `;
  }

  async function cartToHtml(cartPromise) {
    const cart = await cartPromise;
    const taggingContent = `
    ${await cart.items.map((item) => lineItemToHtml(item))}
    `;
    return taggingContent;
  }

  function updateNostoCarouselContents() {
    window.nostojs(async (api) => {
      try {
        const response = await fetch(
          "https://www.explodingkittens.com/cart.js"
        );

        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }

        const jsonData = await response.json();
        const tagging = await cartToHtml(jsonData);

        document
          .querySelectorAll("product-item.nosto-item")
          .forEach((element) => element.remove());

        const nostoCartEl = document.createElement("div");
        nostoCartEl.classList.add("nosto_cart");
        nostoCartEl.style.display = "none";
        nostoCartEl.innerHTML = tagging;

        document.body.append(nostoCartEl);

        api.resendCartTagging();
        callNostoLoadRecommendations();
      } catch (error) {
        console.error(error);
      }
    });
  }

  // Sets up MutationObservers on the mini cart to:
  // 1. Load the nosto recommendations cart widget whenever the nosto_element is removed from the mini cart
  // 2. Detect when the cart drawer is opened and inject the GTM 'acn_view_cart' event script.
  if (miniCartEl) {
    const nostoObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.removedNodes.forEach((removedNode) => {
            if (removedNode.nodeType === Node.ELEMENT_NODE) {
              const nostoElement = removedNode.querySelector(".nosto_element");

              if (nostoElement) {
                updateNostoCarouselContents();
              }
            }
          });
        }
      });
    });
    nostoObserver.observe(miniCartEl, { childList: true, subtree: true });

    const debouncedInjectGTMViewCart = debounce(() => {
      const templateScript = document.querySelector("#gtm-datalayer-view-cart");

      if (templateScript) {
        const acnGtmViewCart = document.createElement("script");
        acnGtmViewCart.textContent = templateScript.textContent;
        document.body.appendChild(acnGtmViewCart);
      }
    }, 300);

    const cartOpenObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open"
        ) {
          const isOpen = miniCartEl.hasAttribute("open");

          if (isOpen) {
            debouncedInjectGTMViewCart();
          }
        }
      });
    });

    cartOpenObserver.observe(miniCartEl, { attributes: true });
  } else {
    console.error("Mini cart element not found");
  }

  // Language selector logic for rich-text.liquid
  function updateSelectedValue(optionId, selectedValue) {
    const selectedValueElement = document.getElementById(`${optionId}-value`);
    if (selectedValueElement) {
      selectedValueElement.textContent = selectedValue;
    }

    const selectElement = document.querySelector(
      `select[name="option${optionId}"]`
    );
    if (selectElement) {
      selectElement.value = selectedValue;
    }

    updateURLWithLanguage(selectedValue.toLowerCase());
  }

  let previousHandle = "";

  // Replaces the language suffix in download URLs with the selected language.
  // If the label includes a language in parentheses (e.g., "(Thai)"), that value is used instead.
  function updateURLWithLanguage(selectedLanguage) {
    const match = selectedLanguage.match(/\(([^)]+)\)/);
    const languageForURL = match
      ? match[1].trim().toLowerCase()
      : selectedLanguage.trim().replace(" ", "-").toLowerCase();
    const links = document.querySelectorAll(".btn--download-language");
    links.forEach((link) => {
      const currentUrl = link.getAttribute("href");
      if (currentUrl) {
        let newUrl = "";
        if (previousHandle === "") {
          newUrl = currentUrl.replace(
            /-(\w+)(?=\.\w+($|\?))/,
            `-${languageForURL}`
          );
        } else {
          newUrl = currentUrl.replace(
            `-${previousHandle}`,
            `-${languageForURL}`
          );
        }
        link.setAttribute("href", newUrl);
        previousHandle = languageForURL;
      }
    });
  }

  // Remove duplicate options from the combo box
  document.querySelectorAll(".combo-box__option-list").forEach((list) => {
    const seenValues = new Set();
    list.querySelectorAll(".combo-box__option").forEach((option) => {
      const value = option.getAttribute("data-value");
      if (seenValues.has(value)) {
        option.remove();
      } else {
        seenValues.add(value);
      }
    });
  });

  // Add event listeners to combo box options
  document.querySelectorAll(".combo-box__option-item").forEach((option) => {
    const selectOption = () => {
      const optionId = option.getAttribute("data-option-id");
      const selectedValue = option.getAttribute("data-value");
      updateSelectedValue(optionId, selectedValue);
    };

    option.addEventListener("click", selectOption);
    option.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        selectOption();
      }
    });
  });
});
